<template>
  <div class="mm-button" :loading="loading">
    <el-popover placement="bottom-end" trigger="hover">
      <div class="spaceLeft">
        <img class="mm-logo" src="../../../assets/logo/mm-logo.png">
        <account v-if="account" class="mm-text" :value="account" />
        <el-button v-else type="text" class="mm-text" @click="connectMetaMask">{{ btnText }}</el-button>
      </div>
      <div slot="reference">
        <img
          v-if="btnText == 'Connected'"
          class="asset-img"
          src="@/assets/image/login/assetLogin.svg"
        >
        <img
          v-else
          class="asset-img"
          src="@/assets/image/login/assetLogout.svg"
        >
      </div>
    </el-popover>
  </div>
</template>

<script>
import MetaMaskOnboarding from '@metamask/onboarding'
import metaMask from './metaMask.js'
import { CheckAccount } from '@/layout/components/metaMaskInit/accountHandler.js'
import {
  ensureTreasureNetwork,
  getEthereumProvider,
  getNetworkErrorMessage,
  isExpectedChain,
  syncChainState
} from '@/utils/metamaskNetwork.js'

export default {
  data() {
    return {
      isInstall: true,
      isConnect: false,
      btnText: 'Install MetaMask',
      loading: false,
      isLog: true,
      account: undefined,
      ethereumProvider: undefined,
      handleAccountsChanged: undefined,
      handleChainChanged: undefined
    }
  },
  async created() {
    await this.init()
    this.$store.commit('app/SET_MATEMASK', { initOk: true })
    if (!this.ethereumProvider) {
      return
    }
    this.ethereumProvider.autoRefreshOnNetworkChange = false
    await this.joinNet()
    CheckAccount()
    this.registerProviderEvents()
  },
  beforeDestroy() {
    if (this.ethereumProvider && this.handleAccountsChanged) {
      this.ethereumProvider.removeListener('accountsChanged', this.handleAccountsChanged)
    }
    if (this.ethereumProvider && this.handleChainChanged) {
      this.ethereumProvider.removeListener('chainChanged', this.handleChainChanged)
    }
  },
  methods: {
    async init() {
      this.isInstall = metaMask.isMetaMaskInstalled()
      this.$store.commit('app/SET_MATEMASK', { isInstall: this.isInstall })
      this.ethereumProvider = getEthereumProvider()
      if (this.isInstall) {
        await this.connectMetaMask()
      }
    },
    async connectMetaMask() {
      if (this.isConnect) {
        return
      }
      if (!this.isInstall) {
        this.loading = true
        this.btnText = 'Onboarding in progress'
        const onboarding = new MetaMaskOnboarding()
        onboarding.startOnboarding()
      } else {
        this.loading = false
        this.btnText = 'Connect MetaMask'
        await this.onClickConnect()
      }
    },
    async onClickConnect() {
      try {
        this.loading = true
        if (!this.ethereumProvider) {
          this.loading = false
          this.$store.commit('app/SET_MATEMASK', { isConnect: false })
          return
        }
        await this.ethereumProvider.request({ method: 'eth_requestAccounts' })
        const accounts = await this.ethereumProvider.request({ method: 'eth_accounts' })
        if (!accounts[0]) {
          this.$message.error('Not able to get accounts')
          this.account = undefined
          this.btnText = 'Connect MetaMask'
          this.isConnect = false
          this.$store.commit('app/SET_MATEMASK', {
            isConnect: false,
            account: undefined
          })
        } else {
          this.account = accounts[0]
          this.btnText = 'Connected'
          this.isConnect = true
          this.$store.commit('app/SET_MATEMASK', {
            isConnect: true,
            account: accounts[0]
          })
        }
        this.loading = false
      } catch (error) {
        this.loading = false
        this.$store.commit('app/SET_MATEMASK', { isConnect: false, account: undefined })
        this.btnText = 'Connect MetaMask'
      }
    },
    async joinNet() {
      try {
        await ensureTreasureNetwork(this.ethereumProvider)
        this.$store.commit('app/SET_MATEMASK', { isJoinNet: true })
      } catch (error) {
        this.loading = false
        this.$store.commit('app/SET_MATEMASK', { isJoinNet: false })
        this.$message.error(getNetworkErrorMessage(error))
      }
    },
    registerProviderEvents() {
      if (!this.ethereumProvider) {
        return
      }

      this.handleAccountsChanged = () => {
        this.$store.dispatch('LogOut').then(() => {
          location.reload()
        })
      }

      this.handleChainChanged = (chainId) => {
        syncChainState(chainId, (...args) => this.$store.commit(...args))
        if (this.$store.getters.metaMaskObj.stopRefreshJoinNet) {
          if (!isExpectedChain(chainId)) {
            this.$message.error('connection failed! ')
          }
          return
        }
        window.location.reload()
      }

      this.ethereumProvider.on('accountsChanged', this.handleAccountsChanged)
      this.ethereumProvider.on('chainChanged', this.handleChainChanged)
    }
  }
}
</script>

<style lang="scss" scoped>
.mm-button {
  display: inline-block;
  background: transparent;
  cursor: pointer;
  color: #1f1f1f;
  margin: 0 0.32rem 0 0;

  .asset-img {
    height: 0.19rem;
    position: relative;
    top: 0.01rem;
  }
}
.mm-logo {
  height: 0.26rem;
  margin-right: 0.16rem;
  position: relative;
  top: 0.03rem;
}
.mm-text {
  position: relative;
  top: 0.02rem;
}
</style>
